import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";

@Injectable()
export class UnauthInterceptorService implements HttpInterceptor {
    constructor (private _authService: AuthService, private _router: Router) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap({
                error: (err:any) => {
                    if (err instanceof HttpErrorResponse) {                        
                        if (err.status === 401 ) {     
                            this._authService.logout();
                            this._router.navigate(['auth/logout'], {queryParams: {returnUrl: this._router.routerState.snapshot.url}})
                        }
                    }
                }
            })
        )
    }

}